module.exports = __webpack_public_path__ + "images/frontpage_hotkeys@1x.png?7eeb4ab4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_hotkeys@1x.png
// module id = 645
// module chunks = 7